import React from 'react';
import { Info } from 'react-feather';

interface Props {
  title: string;
  message?: string;
}

export const InfoToast: React.FC<Props> = ({ title, message }) => {
  return (
    <>
      <div className="toastify-header">
        <div className="title-wrapper">
          <Info
            size={24}
            fill="#7180b7"
            stroke="white"
            className="flex-shrink-0"
          />
          <h6 className="toast-title text-dark">{title}</h6>
        </div>
      </div>
      {!!message && (
        <div className="toastify-body">
          <span role="img" aria-label="toast-text">
            {message}
          </span>
        </div>
      )}
    </>
  );
};
